import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { CreateDailyReportComponent } from '../components/create-daily-report/create-daily-report.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from '../core/projects.service';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';
import { LocationPickerLauncherService } from '../../../shared/services/location-picker-launcher.service';
import { CommonService } from '../../../shared/services/common.service';
import {
  BidItemDetailsAddBidItemComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/bid-item-details/bid-item-details-add-bid-item/bid-item-details-add-bid-item.component';
import {
  AddItemPostingComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/item-postings/add-item-posting/add-item-posting.component';
import {
  ActivityItemDetailsComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/activitiy-details/activity-item-details/activity-item-details.component';
import {
  NotesDetailsComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/notes-details/notes-details.component';
import {
  AddDeliveryDetailsComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/delivery-details/add-delivery-details/add-delivery-details.component';
import {
  AddUsageDetailsComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/usage-details/add-usage-details/add-usage-details.component';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../state/app.state';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../shared/components';
import { SetCurrentLocation } from '../core/projects.actions';
import * as $ from 'jquery';
import {
  LaborDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/labor-details/labor-details-wrapper/labor-details-wrapper.component';
import { dailyReport, projectDetails } from '../core/projects.selectors';
import {
  EquipmentDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/equipment-details/equipment-details-wrapper/equipment-details-wrapper.component';
import {
  IssueDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/issue-details/issue-details-wrapper/issue-details-wrapper.component';
import {
  WeatherDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/weather-details/weather-details-wrapper/weather-details-wrapper.component';
import { MapService } from 'src/app/shared/services/map.service';
import {
  CreateInternalTestComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/internal-test-details/create-internal-test/create-internal-test.component';
import { appDataDetails, translations } from '../../../shared/core/shared.selectors';
import {
  ActivityCodesDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/activity-codes-details/activity-codes-details-wrapper/activity-codes-details-wrapper.component';
import { FetchAppDataRequest } from '../../../shared/core/shared.actions';
import {
  projectForRoute,
  resolveWidgetConfig,
  WidgetConfigAppData,
  WidgetConfigProject,
} from '../../../shared/helpers/project-widget-config';
import {
  ControlFormDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/control-forms-details/control-form-details-wrapper/control-form-details-wrapper.component';
import {
  TestingFormDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/testing-form-details/testing-form-details-wrapper/testing-form-details-wrapper.component';
import { AuthService } from '../../../shared/services';
import { Ability } from '@casl/ability';
import {
  dailyDiaryCreateSubject,
} from '../pages/site-details-page/tab-screens/daily-diary/daily-diary-ability.util';
import {
  isDiaryDetailMode,
} from '../pages/site-details-page/tab-screens/daily-diary/daily-diary-mode.util';
import {
  ExternalTestDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/external-test-details-wrapper/external-test-details-wrapper.component';
import {
  CleContractorDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-contractor-details-wrapper/cle-contractor-details-wrapper.component';
import {
  CleLaborDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-labor-details-wrapper/cle-labor-details-wrapper.component';
import {
  CleEquipmentDetailsWrapperComponent,
} from '../pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-equipment-details-wrapper/cle-equipment-details-wrapper.component';

@Component({
    selector: 'app-projects-wrapper',
    templateUrl: './projects-wrapper.component.html',
    styleUrls: ['./projects-wrapper.component.scss'],
    animations: [
        trigger('rightAnimation', [
            state('*', style({
                width: '0px',
            })),
            state('sidenavOpen', style({
                width: '535px',
            })),
            state('sidenavClosed', style({
                width: '0px',
            })),
            transition('*=>sidenavOpen', animate('500ms')),
            transition('* => void, * => sidenavClosed', animate('500ms')),
        ]),
        trigger('legendAnimation', [
            state('visible', style({
                transform: 'translate(0%, 0%) scale(1)',
                opacity: 1,
            })),
            state('void, hidden', style({
                transform: 'translate(-30%, 25%) scale(0.4)',
                opacity: 0,
            })),
            transition('* => visible', animate('250ms')),
            transition('* => void, * => hidden', animate('250ms')),
        ]),
    ],
    standalone: false
})
export class ProjectsWrapperComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef }) container;
  /** Component type last mounted in the right panel (see createComponent). */
  private lastPanelComponent: any = null;
  isFullScreen = false;
  isLevelThreeMarkerClicked = false;
  showSidenav = false;
  pageSlug: string;
  isDailyReportMenuOpen = false;
  dailyReportMenuConfig: any = [];
  dailyReport: any;
  data: any;
  issues: any;
  report: any = {};
  cleDetails: any = {};
  translations: any = {};
  drWidgetConfig: any = [];
  appDataDetails: any;
  /**
   * Last appdata that carried a widget config. Appdata is refetched (and
   * emptied meanwhile) on entering a site; the + menu keeps the org's widgets
   * through that, as it always has.
   */
  private widgetAppData: WidgetConfigAppData;
  private project: WidgetConfigProject;
  editable: any;
  account: any;
  role: any;
  actingRole: any;
  projectId: string;
  showAddDiv = false;
  showDiaryAddDiv = false;
  isDailyDiaryMenuOpen = false;
  private diaryTabActive = false;
  private diaryDetail = false;
  private diaryDayHasRecord = false;
  /**
   * The diary's component menu, the counterpart of `dailyReportMenuConfig`.
   * Only used in detail mode, where + adds a component to the open record
   * rather than starting a new diary.
   */
  // No Weather entry: a diary's weather is filled in from the weather service
  // when the record is created, the same as a daily report's, so there is
  // nothing to "add" — it is edited from the Weather section in the body.
  dailyDiaryMenuConfig: { icon: string; label: string; handler: () => void }[] = [
    {
      icon: 'daily-report-page-menu-activities',
      label: 'Remarks',
      handler: () => this.triggerAddDiaryComponent('remark'),
    },
  ];
  private readonly onDestroy: Subject<any> = new Subject<any>();
  private readonly locationPickerLauncher = inject(LocationPickerLauncherService);

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private projectsService: ProjectsService,
    private mapService: MapService,
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private cdRef: ChangeDetectorRef,
    private authService: AuthService,
    @Inject(Ability) private ability: Ability,
  ) {

  }

  ngOnInit() {
    const url = this.router.url;
    const path = url.split('?')[0];
    const segments = path.split('/');
    this.projectId = segments[segments.length - 1];
    this.account = this.authService.getCurrentUser();
    this.role = this.account.roles.find(obj => obj.project_id === this.projectId)?.role;

    this.account.roles.forEach(role => {
      if (role?.role === 'reviewer' || role?.role === 'contractor-basic') {
        this.actingRole = 'contractor-basic';
      }
    });

    this.store.dispatch(FetchAppDataRequest());

    // Warm the design-catalog check as soon as a project is known, so the first
    // Location pin tap in any of its editors opens without waiting on it.
    this.store.select(projectDetails)
      .pipe(map((project: { id?: string } | null) => project?.id), filter(Boolean), distinctUntilChanged(), takeUntil(this.onDestroy))
      .subscribe((projectId: string) => this.locationPickerLauncher.prewarm(projectId));

    this.store.select(translations)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((t: any) => {
        this.translations = t || {};
        this.createDailyReportMenuConfig();
      });

    this.store.select(appDataDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data: any) => {
        this.appDataDetails = data;

        if (data?.widgetConfig?.length) {
          this.widgetAppData = data;
        }

        this.refreshDailyReportWidgetConfig();
      });

    // A project can replace the org's widgets with its own (widget_config).
    // This wrapper outlives the project pages, so the + menu is rebuilt each
    // time the store's project changes, including when it is cleared for the
    // next project's fetch.
    this.store.select(projectDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(project => {
        this.project = project;
        this.refreshDailyReportWidgetConfig();
      });

    this.projectsService.actingRole
      .pipe(takeUntil(this.onDestroy))
      .subscribe((ar) => {
        this.actingRole = ar;
      });

    this.projectsService.closeCreateDailyReportDialog
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.dialog.closeAll();
      });

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        const pageUrl = this.router.url.split('?')[0];
        const tab = qp['tab'];

        // Default state: hide button
        this.showAddDiv = false;
        this.diaryTabActive = this.canAddDailyDiary(pageUrl, tab);
        this.diaryDetail = isDiaryDetailMode(qp);
        this.refreshDiaryAddButton();

        if (pageUrl === '/projects') {
          // Always show for /projects
          this.showAddDiv = true;
        } else if (pageUrl.startsWith('/projects/') && !pageUrl.includes('/sites/')) {
          // Only show when tab = 'sites'
          this.showAddDiv = tab === 'sites';
        } else if (pageUrl.includes('/sites/') && tab === 'daily-report') {
          // Allowed on site details page for daily-report only
          this.showAddDiv = true;
        } else {
          this.showAddDiv = false;
        }

        this.isFullScreen = 'fs' in qp;

        if (qp && qp['editable']) {
          this.editable = qp['editable'] === '1';
        } else {
          this.editable = true;
        }
        if (!this.ability.can('create', 'DailyReport')) {
          this.editable = false;
        }
      });

    this.projectsService.diaryDayHasRecord
      .pipe(takeUntil(this.onDestroy))
      .subscribe(hasRecord => {
        this.diaryDayHasRecord = hasRecord;
        this.refreshDiaryAddButton();
        this.cdRef.detectChanges();
      });

    this.projectsService.openRightPanel
      .pipe(takeUntil(this.onDestroy))
      .subscribe(params => {
        this.showSidenav = true;
        setTimeout(() => {
          this.createComponent(params?.component, params?.data, params?.options);
          this.cdRef.detectChanges();
        }, 300);
      });

    this.projectsService.closeRightPanel
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.router.navigate([], {
          queryParams: {
            selectedId: null,
            // The risk register's open-panel deep link (risk-register-list).
            riskId: null,
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          this.showSidenav = false;
          this.container?.clear();
          this.projectsService.rightPanelClosed.next();
        });
        this.commonService.clearRowSelection.next();
      });

    this.store.select(dailyReport)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((report: any) => {
        this.report = report;
        this.cleDetails = {
          contractors: this.report?.reportDetails?.sub_contractors || [],
          labors: this.report?.reportDetails?.labors || [],
          equipments: this.report?.reportDetails?.equipments || [],
        };

        this.syncWeatherMenuOption();
      });

    this.isLevelThreeMarkerClicked = this.commonService.getCurrentlevelThreeClick();

    this.commonService.levelThreeMarkerData
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.data = data;
      });

    this.commonService.levelThreeClick$
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.isLevelThreeMarkerClicked = this.commonService.getCurrentlevelThreeClick();
      });

    navigator.geolocation.getCurrentPosition((position) => {
      const location = {
        longitude: position?.coords?.longitude || null,
        latitude: position?.coords?.latitude || null,
      };

      this.store.dispatch(SetCurrentLocation({ location }));
    });

  }

  ngAfterViewInit() {
    $('app-projects-wrapper .wrapper .left').scroll(() => {
      if ($('app-projects-wrapper .wrapper .left').scrollTop() > 200) {
        this.commonService.setHeaderBgWhite.next(true);
      } else {
        this.commonService.setHeaderBgWhite.next(false);
      }
    });
  }

  close() {
    const isFormDirty = this.projectsService.isAnyFormDirty.getValue();

    if (isFormDirty) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        data: new ConfirmDialogModel(
          'Unsaved changes',
          `There are unsaved changes.<br/>Are you sure you want to discard?`,
        ),
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.projectsService.closeRightPanel.next();
          this.projectsService.isAnyFormDirty.next(false);
          const currentTab = this.route.snapshot.queryParams['tab'];
          const closeParams: any = { cor: null, ciwr: null, snSubTab: null, submittalsItemId: null, rifId: null, selectedId: null, riskId: null };
          if (currentTab !== 'warranty' && !(currentTab === 'settings'
            && ['overlays', 'map-layers'].includes(this.route.snapshot.queryParams['subTab']))) closeParams.subTab = null;
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: closeParams,
            queryParamsHandling: 'merge',
          });
        }
      });
    } else {
      this.projectsService.closeRightPanel.next();
      this.projectsService.isAnyFormDirty.next(false);
      this.commonService.setCloseSideNav(true);
      const currentTab = this.route.snapshot.queryParams['tab'];
      const closeParams: any = { cor: null, ciwr: null, snSubTab: null, submittalsItemId: null, rifId: null, selectedId: null, riskId: null };
      if (currentTab !== 'warranty' && !(currentTab === 'settings'
            && ['overlays', 'map-layers'].includes(this.route.snapshot.queryParams['subTab']))) closeParams.subTab = null;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: closeParams,
        queryParamsHandling: 'merge',
      });
    }
  }

  goBack() {
    if (this.data) {
      this.mapService.openSidenavOnMarkerClick(this.data);
    }
    this.isLevelThreeMarkerClicked = false;
  }

  createComponent(component, data, options = {}) {
    this.container?.clear();

    const componentRef = this.container?.createComponent(component);
    // The panel can close before its open timer fires.
    if (!componentRef) return;
    componentRef.instance.data = data;
    componentRef.instance.options = options;

    // The panel keeps whatever scroll offset the previous content left
    // behind (e.g. a sample opened from an acceptance record deep inside a
    // long item-postings panel came up with its heading 300px above the
    // fold). A different component is a new panel, so start it at the top;
    // the same component re-opened keeps its place.
    if (component !== this.lastPanelComponent) {
      $('app-projects-wrapper .wrapper .right').scrollTop(0);
    }
    this.lastPanelComponent = component;
  }

  /**
   * The diary + is only offered on the site details page's Daily diary tab, in
   * that tab's LIST mode, and only where the user can actually create a diary.
   * The ability check goes through `daily-diary-ability.util` like every other
   * diary check; the mode through `daily-diary-mode.util`.
   *
   * Mode B genuinely removes the button from the DOM rather than covering it —
   * the whole `.add-button` block is behind this flag.
   */
  /**
   * The + shows on the diary tab in BOTH modes, like the daily report's does:
   * browsing, it starts a new diary; on an open record, it adds a component to
   * that record.
   */
  private canAddDailyDiary(pageUrl: string, tab: string): boolean {
    // Diaries live on the PROJECT page now (`/projects/:id?tab=diary`), not on
    // a site's tab bar.
    const projectPage = /^\/projects\/[a-zA-Z0-9]{20,25}$/.test(pageUrl);
    if (!projectPage || tab !== 'diary') return false;
    const projectId = pageUrl.split('/').pop();
    if (!projectId) return false;
    // No site in the url here; the create dialog resolves the project's site.
    return this.ability.can('create', dailyDiaryCreateSubject(projectId, null));
  }

  /**
   * The + is hidden on a day with no diary: in the record view it adds a
   * component to the open diary, and there is nothing to add one to. A diary
   * for that day is started from the list instead.
   */
  private refreshDiaryAddButton() {
    this.showDiaryAddDiv = this.diaryTabActive
      && (!this.diaryDetail || this.diaryDayHasRecord);
  }

  handleAddDiary() {
    // Detail mode: open the component menu (Weather / Remarks) rather than the
    // create dialog — same behaviour as + on an open daily report.
    if (isDiaryDetailMode(this.route.snapshot.queryParams)) {
      this.isDailyDiaryMenuOpen = !this.isDailyDiaryMenuOpen;
      return;
    }
    this.projectsService.createDailyDiary.next();
  }

  triggerAddDiaryComponent(type: string) {
    this.isDailyDiaryMenuOpen = false;
    this.projectsService.addDailyDiaryComponent.next(type);
  }

  handleAdd() {
    const currentRoute = this.router.url.split('?')[0];

    if (currentRoute === '/projects') {
      this.dialog.open(CreateDailyReportComponent, {
        disableClose: false,
        data: { x: 3 },
        panelClass: 'floating-dialog-box',
      });
      return;
    }

    const projectDetailsPageUrlRegex = /^\/projects\/[a-zA-Z0-9]{20,25}$/;
    if (projectDetailsPageUrlRegex.test(currentRoute)) {
      this.dialog.open(CreateDailyReportComponent, {
        disableClose: false,
        panelClass: 'floating-dialog-box',
        data: {
          projectId: currentRoute.split('/').pop(),
        },
      });
      return;
    }

    const siteDetailsUrlRegex = /^\/projects\/[a-zA-Z0-9]{20,25}\/sites\/[a-zA-Z0-9]{20,25}$/;
    if (
      siteDetailsUrlRegex.test(currentRoute) &&
      this.route.snapshot.queryParams['tab'] &&
      this.route.snapshot.queryParams['tab'] === 'daily-report'
      && Object.keys(this.report).length > 0
    ) {
      this.pageSlug = 'daily-report';
      // Resolve against the project in the url at the moment the menu opens.
      this.refreshDailyReportWidgetConfig();
      this.isDailyReportMenuOpen = true;
    } else {
      const date = this.route.snapshot.queryParams['date'];

      this.dialog.open(CreateDailyReportComponent, {
        disableClose: false,
        panelClass: 'floating-dialog-box',
        data: {
          siteId: currentRoute.split('/').pop(),
          projectId: currentRoute.split('/')[2],
          date,
        },
      });
    }
  }

  triggerAddElementToDailyReport(type) {
    const isFormDirty = this.projectsService.isAnyFormDirty.getValue();

    if (isFormDirty) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        data: new ConfirmDialogModel(
          'Unsaved changes',
          `There are unsaved changes.<br/>Are you sure you want to discard?`,
        ),
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.addElementToDailyReport(type);
          this.projectsService.isAnyFormDirty.next(false);
        }
      });
    } else {
      this.addElementToDailyReport(type);
    }

    this.isDailyReportMenuOpen = false;
  }

  addElementToDailyReport(type) {
    switch (type) {
      case 'weather':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'weather',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: WeatherDetailsWrapperComponent,
            });
            $(`#weather`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'bidItem':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'bid-item',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: BidItemDetailsAddBidItemComponent,
            });
            $(`#bid-item`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'item-postings':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'item-postings',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: AddItemPostingComponent,
            });
            $(`#item-postings`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'delivery':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'delivery-usage',
            idx: '0',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: AddDeliveryDetailsComponent,
            });
            $(`#delivery-usage`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'usage':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'delivery-usage',
            idx: 1,
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: AddUsageDetailsComponent,
            });
            $(`#delivery-usage`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'activity':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'activities',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: ActivityItemDetailsComponent,
            });
            $(`#activities`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'notes':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'notes',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: NotesDetailsComponent,
            });
            $(`#notes`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'labor':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'labor-equipment',
            idx: -1,
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.store.select(projectDetails).subscribe(data => {
              this.projectsService.openRightPanel.next({
                component: LaborDetailsWrapperComponent,
                data: {
                  newDataFormat: data.new_labor_format,
                },
              });
              $(`#labor-equipment`)[0]?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }).unsubscribe();
          });
        });
        break;

      case 'equipment':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'labor-equipment',
            idx: 1,
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.store.select(projectDetails).subscribe(data => {
              this.projectsService.openRightPanel.next({
                component: EquipmentDetailsWrapperComponent,
                data: {
                  newDataFormat: data.new_labor_format,
                },
              });
              $(`#labor-equipment`)[0]?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }).unsubscribe();
          });
        });
        break;

      case 'cle-contractor':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'contractor-labor-equipment',
            idx: 0,
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: CleContractorDetailsWrapperComponent,
              data: this.cleDetails,
            });
            $(`#contractor-labor-equipment`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'cle-labor':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'contractor-labor-equipment',
            idx: 1,
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: CleLaborDetailsWrapperComponent,
            });
            $(`#contractor-labor-equipment`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'cle-equipment':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'contractor-labor-equipment',
            idx: 2,
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: CleEquipmentDetailsWrapperComponent,
            });
            $(`#contractor-labor-equipment`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'issues':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'issues',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {

            this.projectsService.openRightPanel.next({
              component: IssueDetailsWrapperComponent,
            });
            $(`#issues`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'internalTest':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'material-testing',
            idx: -1,
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: CreateInternalTestComponent,
            });
            $(`#material-testing`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'externalTest':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'material-testing',
            idx: 1,
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {
            this.projectsService.openRightPanel.next({
              component: ExternalTestDetailsWrapperComponent,
              data: {},
            });
            $(`#material-testing`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'activityCodes':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'activity-codes',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {

            this.projectsService.openRightPanel.next({
              component: ActivityCodesDetailsWrapperComponent,
            });
            $(`#activity-codes`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'forms':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'forms',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {

            this.projectsService.openRightPanel.next({
              component: ControlFormDetailsWrapperComponent,
            });
            $(`#forms`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'controlForms':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'control-forms',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {

            this.projectsService.openRightPanel.next({
              component: ControlFormDetailsWrapperComponent,
            });
            $(`#control-forms`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      case 'testingForms':
        this.router.navigate([], {
          queryParams: {
            expandedSection: 'testing-forms',
          },
          queryParamsHandling: 'merge',
        }).then(() => {
          setTimeout(() => {

            this.projectsService.openRightPanel.next({
              component: TestingFormDetailsWrapperComponent,
            });
            $(`#testing-forms`)[0]?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          });
        });
        break;

      default:
        return [];
    }
  }

  /**
   * Widgets of the project on screen: its own widget_config when it has one,
   * the org's otherwise. The project is taken from the store only when it is
   * the one in the url; until then (still loading, or another project's left
   * over) the org config stands.
   */
  private refreshDailyReportWidgetConfig() {
    const projectId = this.router.url.split('?')[0].split('/')[2];
    const tempData = resolveWidgetConfig(this.widgetAppData, projectForRoute(this.project, projectId))
      .filter(o => o.display);
    tempData.sort((a, b) => a.display_order - b.display_order);
    this.drWidgetConfig = tempData;

    this.createDailyReportMenuConfig();
  }

  createDailyReportMenuConfig() {
    this.dailyReportMenuConfig = [];

    if (this.drWidgetConfig?.length > 0) {
      this.dailyReportMenuConfig = this.drWidgetConfig
        .filter((item: any) => item?.display)
        .sort((a: any, b: any) => a.display_order - b.display_order)
        .map((item: any) => this.getMenuItemsForWidget(item?.name, this.translations))
        .reduce((acc: any, val: any) => acc.concat(val), []);
    }

    this.syncWeatherMenuOption();
  }

  /**
   * "Weather" is offered while the open report has none, and only where the
   * weather widget is shown: without the widget there is no section to open.
   * Runs on every rebuild of the menu so the entry survives one.
   */
  private syncWeatherMenuOption() {
    const index = this.dailyReportMenuConfig.findIndex(item => item.label === 'Weather');
    const weatherMissing = this.report?.weather === null || this.report?.weather === undefined;
    const weatherShown = this.drWidgetConfig?.some(item => item?.name === 'weather' && item?.display);

    if (weatherMissing && weatherShown) {
      if (index === -1) {
        this.dailyReportMenuConfig.unshift(
          {
            icon: 'daily-report-page-weather',
            label: 'Weather',
            handler: () => this.triggerAddElementToDailyReport('weather'),
          },
        );
      }
    } else if (index !== -1) {
      this.dailyReportMenuConfig.splice(index, 1);
    }
  }

  getMenuItemsForWidget(name: string, translation: any) {
    switch (name) {
      case 'bid_items':
        return [
          {
            icon: 'daily-report-page-menu-bid-item',
            label: 'Bid item',
            handler: () => this.triggerAddElementToDailyReport('bidItem'),
          },
        ];

      case 'item-postings':
        return [
          {
            icon: 'daily-report-page-menu-bid-item',
            label: 'Item posting',
            handler: () => this.triggerAddElementToDailyReport('item-postings'),
          },
        ];

      case 'deliveries':
        return [
          {
            icon: 'daily-report-page-menu-delivery',
            label: 'Delivery',
            handler: () => this.triggerAddElementToDailyReport('delivery'),
          },
          {
            icon: 'daily-report-page-menu-usage',
            label: 'Usage',
            handler: () => this.triggerAddElementToDailyReport('usage'),
          },
        ];

      case 'testing':
        return [
          {
            icon: 'daily-report-page-menu-external-test',
            label: 'Offsite test',
            handler: () => this.triggerAddElementToDailyReport('externalTest'),
          },
          {
            icon: 'daily-report-page-menu-internal-test',
            label: 'Onsite test',
            handler: () => {
              console.log('Add');
            },
          },
        ];

      case 'issues':
        return [
          {
            icon: 'daily-report-page-menu-issues',
            label: 'Issues',
            handler: () => {
              this.triggerAddElementToDailyReport('issues');
            },
          },
        ];

      case 'labor':
        return [
          {
            icon: 'daily-report-page-menu-labor',
            label: 'Labor',
            handler: () => {
              this.triggerAddElementToDailyReport('labor');
            },
          },
          {
            icon: 'daily-report-page-menu-equipment',
            label: 'Equipment',
            handler: () => {
              this.triggerAddElementToDailyReport('equipment');
            },
          },
        ];

      case 'contractor-labor-equipment':
        return [
          {
            icon: 'daily-report-page-menu-labor',
            label: 'Contractor',
            handler: () => {
              this.triggerAddElementToDailyReport('cle-contractor');
            },
          },
          {
            icon: 'daily-report-page-menu-labor',
            label: 'Labor',
            handler: () => {
              this.triggerAddElementToDailyReport('cle-labor');
            },
          },
          {
            icon: 'daily-report-page-menu-equipment',
            label: 'Equipment',
            handler: () => {
              this.triggerAddElementToDailyReport('cle-equipment');
            },
          },
        ];

      case 'activities':
        return [
          {
            icon: 'daily-report-page-menu-activities',
            label: translation?.ReportActivity?.title || 'Activities',
            handler: () => {
              this.triggerAddElementToDailyReport('activity');
            },
          },
        ];

      case 'notes':
        return [
          {
            icon: 'daily-report-page-menu-activities',
            label: translation?.ReportNotes?.title || 'Notes',
            handler: () => {
              this.triggerAddElementToDailyReport('notes');
            },
          },
        ];

      case 'activity_codes':
        return [
          {
            icon: 'daily-report-page-menu-bid-item',
            label: 'Activity IDs',
            handler: () => {
              this.triggerAddElementToDailyReport('activityCodes');
            },
          },
        ];

      case 'forms':
        return [
          {
            icon: 'daily-report-page-menu-forms',
            label: 'Forms',
            handler: () => {
              this.triggerAddElementToDailyReport('forms');
            },
          },
        ];

      case 'control_forms':
        return [
          {
            icon: 'daily-report-page-menu-forms',
            label: 'Control point forms',
            handler: () => {
              this.triggerAddElementToDailyReport('controlForms');
            },
          },
        ];

      case 'testing_forms':
        return [
          {
            icon: 'daily-report-page-menu-forms',
            label: 'Testing forms',
            handler: () => {
              this.triggerAddElementToDailyReport('testingForms');
            },
          },
        ];

      default:
        return [];
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
